import env from 'env'

export const STATIC_FILES_CDN_URL = `${env.CDN_URL}/static-files/listing-page/`
export const STATIC_FILES_CDN_ICON_URL = `${env.CDN_URL}/static-files/shared-assets/icons`

export const STORAGE = {
  USER_TOKEN: 'rentspreeUserToken',
}

// DOMAIN NAME HAS TO BE OMITTED FOR SHARE COOKIE TO WORK ON LOCALHOST
export const cookieOption = (domainName: string) => ({
  path: '/',
  ...(domainName !== 'localhost' && { domain: domainName }),
})

export const TERMS_OF_USE_URL = 'https://www.rentspree.com/terms-of-use/'
export const PRIVACY_POLICY_URL = 'https://www.rentspree.com/rentspree-privacy-policy/'

export const GCS_PROTOCOL = 'gs://'
export const GOOGLE_CLOUD_STORAGE_HOST = 'https://storage.googleapis.com/'

export const PRESCREEN_FIELDS = {
  moveInDate: {
    label: 'What’s your preferred move-in date?',
    placeholder: 'MM/DD/YYYY',
  },
  preferredLeaseTerm: {
    label: 'What’s your preferred lease term?',
    placeholder: 'Select lease term',
  },
  householdMonthlyIncome: {
    label: 'What’s your household monthly income?',
    placeholder: 'Enter number',
  },
  occupy: {
    label: 'How many people will occupy the unit? (Including yourself)',
    placeholder: 'Enter number',
  },
} as const
export const PRESCREEN_FIELD_KEYS = Object.keys(PRESCREEN_FIELDS)

export const PRESCREEN_LEASE_TERM_OPTIONS = [
  { value: 'Less than 1 year', label: 'Less than 1 year' },
  { value: '1 year', label: '1 year' },
  { value: '2 years', label: '2 years' },
  { value: '2+ years', label: '2+ years' },
]

export const SCREENING_REQUEST_STATUS = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
} as const
